import { observer } from "mobx-react-lite";

import { useNodeThemeColors } from "@/components/expression/theme/useNodeTheme";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

type Props = {
  node: DecoratorNodeModel;
  count?: number;
  direction?: "left" | "right";
};

export const Accent = observer(function Accent({ node, count = 1, direction = "left" }: Props) {
  const { parent: symbolNode } = node;

  const { view, size } = useNodeStyle();
  const theme = useNodeThemeColors(symbolNode?.parent);

  const isTextView = view === "text";

  return (
    <div
      className={twMerge(
        "absolute -top-[2px] left-0 w-full flex justify-center gap-[2px]",
        isTextView && size === "xxs" && "top-0",
      )}
    >
      {...Array.from({ length: count }).map((_, i) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`${node.name}-${i}`}
          className={twMerge(
            "h-[5px] w-[1px] rounded-full bg-document-text",

            direction === "left" && "rotate-45",
            direction === "right" && "-rotate-45",

            isTextView && (size === "xxs" || size === "xxxs") && "h-[3px]",

            theme?.symbol && `bg-${theme.symbol.light} dark:bg-${theme.symbol.dark}`,
          )}
        />
      ))}
    </div>
  );
});
